module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-9.fb927113.png";